import { useMemo } from "react";

import { useHistory } from "react-router-dom";
import { AssetTypeWiz } from "@doitintl/cmp-models";
import { Button } from "@mui/material";

import { useCustomerContext } from "../../../Context/CustomerContext";
import NoAssets from "./components/NoAssets";
import { type WizAssetRowData } from "./components/wiz/WizAssetRow";
import WizAssetsTabHeader from "./components/wiz/WizAssetsTabHeader";
import WizAssetTable from "./components/wiz/WizAssetTable";

const WizAssetsTab = ({ wizConfigs }: { wizConfigs: WizAssetRowData[] }) => {
  const { customer } = useCustomerContext();
  const history = useHistory();

  const connectButton = useMemo(
    () => (
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          history.push(`/customers/${customer.id}/cloud-onboarding-wiz`);
        }}
        data-cy="wiz-connect-button"
      >
        Connect new account
      </Button>
    ),
    [customer.id, history]
  );

  if (wizConfigs && wizConfigs.length === 0) {
    return <NoAssets assetType={AssetTypeWiz}>{connectButton}</NoAssets>;
  }

  return (
    <>
      <WizAssetsTabHeader connectButton={connectButton} />
      <WizAssetTable wizConfigs={wizConfigs} />
    </>
  );
};

export default WizAssetsTab;
